import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

import OvertimeFormModal from '@/components/forms/OvertimeFormModal';
import LeaveFormModal from '@/components/forms/LeaveFormModal';
import LeaveTransferFormModal from '@/components/forms/LeaveTransferFormModal';
import WorkDeclarationFormModal from '@/components/forms/WorkDeclarationFormModal';
import TravelExpenseFormModal from '@/components/forms/TravelExpenseFormModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Map form_type → the modal component to render in edit mode.
const MODAL_BY_TYPE = {
  overtime:         OvertimeFormModal,
  leave:            LeaveFormModal,
  leave_transfer:   LeaveTransferFormModal,
  work_declaration: WorkDeclarationFormModal,
  travel_expense:   TravelExpenseFormModal,
};

export default function EditSubmission() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submission, setSubmission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/forms/submissions/${id}`);
        setSubmission(res.data);
      } catch (e) {
        toast.error('読み込みに失敗しました');
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <p className="text-center text-zinc-500 py-12">読み込み中…</p>
    );
  }
  if (!submission) {
    return <p className="text-center text-red-500 py-12">申請が見つかりません</p>;
  }

  const Modal = MODAL_BY_TYPE[submission.form_type];
  if (!Modal) {
    return (
      <p className="text-center text-red-500 py-12">
        この種類の申請は編集できません: {submission.form_type}
      </p>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-4" data-testid="edit-submission-page">
      <div>
        <Button variant="outline" onClick={() => navigate(`/submission/${id}`)} data-testid="btn-back">
          <ArrowLeft size={18} className="mr-2" /> 戻る
        </Button>
      </div>
      <Modal
        embedded
        submissionId={id}
        initialData={submission.form_data}
        onClose={() => navigate(`/submission/${id}`)}
      />
    </div>
  );
}
